import { u as userSchema, p as productSchema, l as loginSchema } from "./validationSchemas.js";
const validate = (formData, schema) => {
  try {
    const result = schema.safeParse(formData);
    if (!result.success) {
      const errors = result.error.flatten().fieldErrors;
      return { success: false, errors };
    }
    return { success: true, data: result.data };
  } catch (error) {
    return {
      success: false,
      errors: { _errors: ["An unexpected error occurred during validation"] }
    };
  }
};
const validateRegistration = (formData) => validate(formData, userSchema);
const validateLogin = (formData) => validate(formData, loginSchema);
const validateProduct = (formData) => validate(formData, productSchema);
export {
  validateRegistration as a,
  validateProduct as b,
  validateLogin as v
};
